var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "report-chat-distributions" } }, [
    _c("div", { staticClass: "overall-content" }, [
      _c(
        "div",
        { staticClass: "chart-container" },
        [
          _c(
            "div",
            { staticClass: "chart-section" },
            [
              _c("h2", [_vm._v(_vm._s(_vm.$t("report.chatCountsByUsers")))]),
              _vm._v(" "),
              _c("ChatDistributionsByUser", {
                attrs: {
                  title: _vm.$t("report.chatCountsByUsers"),
                  filters: _vm.filters,
                  loading: _vm.loading,
                  data: _vm.data.byUser,
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("a-divider"),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "chart-section" },
            [
              _c("h2", [_vm._v(_vm._s(_vm.$t("report.chatCountByPlatform")))]),
              _vm._v(" "),
              _c("ChatDistributionsByPlatform", {
                attrs: {
                  title: _vm.$t("report.chatCountByPlatform"),
                  filters: _vm.filters,
                  loading: _vm.loading,
                  data: _vm.data.byPlatform,
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("a-divider"),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "chart-section" },
            [
              _c("h2", [_vm._v(_vm._s(_vm.$t("report.chatCountsByAns")))]),
              _vm._v(" "),
              _c("ChatDistributionsByAnswer", {
                attrs: {
                  title: _vm.$t("report.chatCountsByAns"),
                  filters: _vm.filters,
                  loading: _vm.loading,
                  data: _vm.data.byAnswer,
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("a-divider"),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "chart-section" },
            [
              _c("h2", [
                _vm._v(_vm._s(_vm.$t("report.chatCountsByHandleType"))),
              ]),
              _vm._v(" "),
              _c("ChatDistributionsByHandleType", {
                attrs: {
                  title: _vm.$t("report.chatCountsByHandleType"),
                  filters: _vm.filters,
                  loading: _vm.loading,
                  data: _vm.data.byHandleType,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }